import { classNames, useQuery } from 'libs/react';
import { Panel } from 'components/Panel';
import { PanelGroup } from 'components/PanelGroup';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { EntityHistoryQuery } from 'graphql/EntityHistory/queries/EntityHistoryQuery';
import { DateTime } from 'components/DateTime';
import { DealItemPanelGroup } from '../components/dealItemPanelGroup/DealItemPanelGroup';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import { getDiscountRep } from 'helpers/Pricing';
import { useAccount } from 'components/account/AccountProvider';
import { useUser } from 'components/user/UserProvider';
import './DealInformationPane.scss';
/**
 * @component DealInformationPane
 * @since 1.0.0
 */
export function DealInformationPane(props) {
    var _a, _b, _c, _d;
    const { style, title, data, hideStats } = Object.assign({ style: 'normal', hideStats: false }, props);
    const account = useAccount();
    const user = useUser();
    const [entityData] = useQuery(EntityHistoryQuery, {
        variables: {
            input: {
                entity: 'DEAL',
                entityId: (_a = data === null || data === void 0 ? void 0 : data.id) !== null && _a !== void 0 ? _a : ''
            }
        }
    });
    const dealLastOpened = entityData === null || entityData === void 0 ? void 0 : entityData.history.filter((h) => h.event == 'QUOTE_OPENED').sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))[0];
    const differenceDateCreation = new Date(Date.now() - Date.parse(data === null || data === void 0 ? void 0 : data.createdAt)).getTime();
    const dealDateSinceCreation = Math.ceil(differenceDateCreation / (1000 * 3600 * 24));
    const numberVisit = entityData === null || entityData === void 0 ? void 0 : entityData.history.filter((h) => h.event == 'QUOTE_OPENED').length;
    /**
     * @function filterRecommendedPackagesOut
     * @since 1.0.0
     * @hidden
     */
    function filterRecommendedPackagesOut(item) {
        var _a;
        return Object.assign(Object.assign({}, item), { packages: (_a = item.packages) === null || _a === void 0 ? void 0 : _a.filter((pack) => !pack.proposed) });
    }
    /**
     * @function filterRecommendedOptionsOut
     * @since 1.0.0
     * @hidden
     */
    function filterRecommendedOptionsOut(item) {
        var _a;
        return Object.assign(Object.assign({}, item), { options: (_a = item.options) === null || _a === void 0 ? void 0 : _a.filter((option) => !option.proposed) });
    }
    const discountRep = getDiscountRep((_b = user.user) === null || _b === void 0 ? void 0 : _b.contact);
    const quantityType = getConfigurationFieldValue((_c = account.configs) !== null && _c !== void 0 ? _c : [], 'QUANTITY_TYPE');
    const pricingParametersDisplay = getConfigurationFieldValue((_d = account.configs) !== null && _d !== void 0 ? _d : [], 'PRICING_PARAMETERS_DISPLAY');
    const className = classNames('deal-information', 'deal-information--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "deal-information-head" }, title && React.createElement(Text, { className: "deal-information-title", value: title })),
        React.createElement("div", { className: "deal-information-body" }, !hideStats && (React.createElement(PanelGroup, null,
            React.createElement(Panel, { title: t('Last opened date') }, dealLastOpened ? (React.createElement(DateTime, { value: dealLastOpened.createdAt, y: "numeric", m: "numeric", d: "numeric", time: true })) : (React.createElement("div", null, t('N/A')))),
            React.createElement(Panel, { title: t('Time since creation') },
                React.createElement("div", null, `${dealDateSinceCreation} ${t('days')}`)),
            React.createElement(Panel, { title: t('Total visits') },
                React.createElement("div", null, numberVisit))))), data === null || data === void 0 ? void 0 :
        data.items.map((item, index) => {
            return (React.createElement("div", { key: index },
                React.createElement("div", null,
                    React.createElement("div", { id: item.id, key: item.id, className: "quote-summary-item" },
                        React.createElement("div", { className: "quote-summary-item-heading" }, item.item.sku),
                        React.createElement("div", { className: "quote-summary-item-content" },
                            React.createElement("div", { className: "deal-item-panel-body" },
                                React.createElement("div", { className: "deal-item-panel-body-section" },
                                    React.createElement(DealItemPanelGroup, { type: "item", item: item, editable: false, discountRep: discountRep, deal: data, quantityType: quantityType, pricingParametersDisplay: pricingParametersDisplay, pricingDisplay: "ALL" })),
                                item.packages &&
                                    item.packages.filter((f) => !f.proposed).length > 0 && (React.createElement("div", { className: "deal-item-panel-body-section" },
                                    React.createElement(DealItemPanelGroup, { type: "package", item: filterRecommendedPackagesOut(item), discountRep: discountRep, editable: false, deal: data, quantityType: quantityType, pricingParametersDisplay: pricingParametersDisplay, pricingDisplay: "ALL" }))),
                                item.options &&
                                    item.options.filter((f) => !f.proposed).length > 0 && (React.createElement("div", { className: "deal-item-panel-body-section" },
                                    React.createElement(DealItemPanelGroup, { type: "option", item: filterRecommendedOptionsOut(item), discountRep: discountRep, editable: false, deal: data, quantityType: quantityType, showIncludedOptions: data.showIncludedOptions, pricingParametersDisplay: pricingParametersDisplay, pricingDisplay: "ALL" })))))))));
        })));
}
